// extracted by css-extract-rspack-plugin
export default {"projectName":"_e667f7b1","projectLocation":"_312e040b"};